import React, { useState } from "react"; // Added useState import
import "bootstrap/dist/css/bootstrap.min.css";
import { Link } from "react-router-dom";
import config from '../functions/config';

const Homepage = () => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleNavbar = () => {
    setIsOpen(!isOpen);
  };
  return (
    <div style={styles.pageContainer}>
      {/* Navbar */}
      <nav className="navbar navbar-expand-lg navbar-dark bg-dark py-3 fixed-top">
      <div className="container-fluid">
        <a className="navbar-brand" href="#">📚 Library</a>
        <button 
          className="navbar-toggler" 
          type="button" 
          onClick={toggleNavbar}
          aria-expanded={isOpen}
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>
        <div className={`collapse navbar-collapse ${isOpen ? "show" : ""}`}>
          <ul className="navbar-nav ms-auto">
            <li className="nav-item">
              <Link className="nav-link" to="/">Home</Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/about">About</Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/login">Login</Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/signup">Register</Link>
            </li>
          </ul>
        </div>
      </div>
    </nav>

      {/* Hero Section */}
      <div style={styles.heroSection}>
        <div className="container text-center text-success " >
          <Link to="/Signup" className="btn btn-light btn-lg mt-4 m-5">Explore now !</Link>
        </div>
        
      </div>
      <div className="container text-center text-warning " >
          <h1 className="display-4 text-x-large border" style={{ fontWeight: '700',borderBlockColor:'red' }}>Welcome to the Library Management System</h1>
          <h3 className="lead text-dark">Efficiently manage books, rentals, and purchases all in one place.</h3>
          <Link to="/Signup" className="btn btn-primary btn-lg mt-4">Get Started</Link>
        </div>


<div className="container">
  
<div className="mb-5">
  <h2 className="text-dark ">📖 Types of Books</h2>
  <div className="container">
    <div className="row g-4">
      {[
        { type: 'Fiction', img: 'https://th.bing.com/th/id/OIP.IjXSQgpeek65QTvREX852QAAAA?rs=1&pid=ImgDetMain' },
        { type: 'Non-Fiction', img: 'https://th.bing.com/th/id/OIP.coCC4Dkmsh2jzF17hva_nQHaLJ?rs=1&pid=ImgDetMain' },
        { type: 'Science', img: 'https://schoolbooks.ie/cdn/shop/products/NOS2IJ-1_800x.jpg?v=1659681825' },
        { type: 'History', img: 'https://d28hgpri8am2if.cloudfront.net/book_images/cvr9781439149959_9781439149959_hr.jpg' },
        { type: 'Technology', img: 'https://th.bing.com/th/id/OIP.NTysc_EarHIFpwJW_LsG8AHaLR?rs=1&pid=ImgDetMain' },
        { type: 'Biography', img: 'https://th.bing.com/th/id/OIP.YKMfmtiwurEnx9ertgQg-gHaL6?rs=1&pid=ImgDetMain' },
        { type: 'Fantasy', img: 'https://th.bing.com/th/id/OIP.XS_rPmWeqK0ptfRshJmy7AAAAA?rs=1&pid=ImgDetMain' },
        { type: 'Mystery', img: 'https://th.bing.com/th/id/OIP.uYn5RsobUKsYlRtKo3BFHAHaLH?rs=1&pid=ImgDetMain' }
      ].map((book, index) => (
        <div key={index} className="col-10 col-sm-6 col-md-4 col-lg-2">
          <div className="card shadow-sm h-100">
            <img src={book.img} className="card-img-top" alt={`${book.type} Books`} />
            <div className="card-body text-center">
              <h5 className="card-title text-primary">{book.type}</h5>
              <p className="card-text">Explore {book.type} books from various authors and genres.</p>
            </div>
          </div>
        </div>
      ))}
    </div>
  </div>
</div>


      {/* Books Published Since Years Ago Section */}
  {/* Books Published Since Years Ago Section */}
<div className="mb-5">
  <h2 className="text-dark text-center">📅 Books Published Since Recent Years</h2>
  <div className="row row-cols-1 row-cols-md-5 g-4 justify-content-center">
    {[2023, 2022, 2021, 2020, 2019].map((year, index) => (
      <div key={index} className="col d-flex justify-content-center">
        <div className="card shadow-sm h-100 text-center">
          <div className="card-body">
            <h5 className="card-title text-success">Year {year}</h5>
            <p className="card-text">Browse books published in {year}.</p>
          </div>
        </div>
      </div>
    ))}
  </div>
</div>

{/* Manager's Recommendations Section */}
<div className="mb-5">
  <h2 className="text-dark text-center">👨‍💼 Manager's Recommendations</h2>
  <div className="row row-cols-1 row-cols-md-5 g-4 justify-content-center">
    {['To Kill a Mockingbird', '1984', 'The Great Gatsby', 'Pride and Prejudice'].map((book, index) => (
      <div key={index} className="col d-flex justify-content-center">
        <div className="card shadow-sm h-100 text-center">
          <div className="card-body">
            <h5 className="card-title text-info">{book}</h5>
            <p className="card-text">Recommended by our library manager for all users.</p>
          </div>
        </div>
      </div>
    ))}
  </div>
</div>

{/* Popular Authors Section */}
<div className="mb-5">
  <h2 className="text-dark text-center">👩‍🎨 Popular Authors</h2>
  <div className="row row-cols-1 row-cols-md-5 g-4 justify-content-center">
    {['J.K. Rowling', 'George Orwell', 'Jane Austen', 'Agatha Christie'].map((author, index) => (
      <div key={index} className="col d-flex justify-content-center">
        <div className="card shadow-sm h-100 text-center">
          <div className="card-body">
            <h5 className="card-title text-warning">{author}</h5>
            <p className="card-text">Discover the best works by {author}.</p>
          </div>
        </div>
      </div>
    ))}
  </div>
</div>

{/* Latest Arrivals Section */}
<div className="mb-5">
  <h2 className="text-dark text-center">📚 Latest Arrivals</h2>
  <div className="row row-cols-1 row-cols-md-5 g-4 justify-content-center">
    {['The Silent Patient', 'Where the Crawdads Sing', 'The Midnight Library', 'Project Hail Mary'].map((book, index) => (
      <div key={index} className="col d-flex justify-content-center">
        <div className="card shadow-sm h-100 text-center">
          <div className="card-body">
            <h5 className="card-title text-danger">{book}</h5>
            <p className="card-text">Check out the latest additions to our collection.</p>
          </div>
        </div>
      </div>
    ))}
  </div>
</div>

{/* Top-Rated Books Section */}
<div className="mb-5">
  <h2 className="text-dark text-center">⭐ Top-Rated Books</h2>
  <div className="row row-cols-1 row-cols-md-5 g-4 justify-content-center">
    {['The Hobbit', 'The Catcher in the Rye', 'The Alchemist', 'Harry Potter Series'].map((book, index) => (
      <div key={index} className="col d-flex justify-content-center">
        <div className="card shadow-sm h-100 text-center">
          <div className="card-body">
            <h5 className="card-title text-dark">{book}</h5>
            <p className="card-text">These books have been rated highly by our readers.</p>
          </div>
        </div>
      </div>
    ))}
  </div>
</div>


      </div>
   

        

      {/* Overview Section */}
      <div className="container my-5">
        <h2 className="text-center mb-4">📖 Project Overview</h2>
        <p className="text-muted text-center">
          The Library Management System offers a seamless way to manage books, rentals, and purchases with ease.
        </p>
        <div className="row">
          {features.map((feature, index) => (
            <div className="col-12 col-sm-6 col-md-4 mb-4" key={index}>
              <div className="card border-0 shadow" style={styles.card}>
                <div className="card-body">
                  <h5 className="card-title">{feature.title}</h5>
                  <p className="card-text">{feature.description}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Footer */}
      <footer style={styles.footer} >
        <p className="mb-0">&copy; 2024 Library Management System | Designed with ❤️ by Your Team</p>
      </footer>
    </div>
  );
};

// Features Data
const features = [
  {
    title: "User Registration & Login",
    description: "Secure registration and login for users and admins."
  },
  {
    title: "Manage Books",
    description: "Admins can add, update, and delete books in the library."
  },
  {
    title: "Book Rentals",
    description: "Users can rent books and view their rental history."
  },
  {
    title: "Real-time Availability",
    description: "Check book availability status in real-time."
  },
  {
    title: "Secure Payments",
    description: "Dummy secure payment flow for purchases."
  },
  {
    title: "User-Friendly Interface",
    description: "Intuitive platform for both admins and users."
  },
];

// Inline Styles
const styles = {
  pageContainer: {
    fontFamily: "'Roboto', sans-serif",
    backgroundColor: "#f8f9fa",
    minHeight: "100vh",
  },
  heroSection: {
    background: "url('https://premierimmigration.com/wp-content/uploads/2015/10/cropped-hjj-1.jpg') no-repeat center center/cover",
    color: "white",
    padding: "80px 0",
    textAlign: "center",
  },
  card: {
    borderRadius: "10px",
    backgroundColor: "#ffffff",
    padding: "20px",
    minHeight: "200px",
  },
  footer: {
    backgroundColor: "#343a40",
    color: "white",
    padding: "15px 0",
    textAlign: "center",
  },
};

export default Homepage;
